/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespSearchResultContainer_itemSearch = {
    readonly pageType: string | null;
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly item: {
                readonly serviceId: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_item">;
            } | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_itemSearch" | "SbSharedItemTrackingProvider_itemSearch" | "useSearchCorrections_itemSearch" | "SbSharedProductAdWrapper_itemSearch" | "SharedItemTile_itemSearch">;
    readonly " $refType": "SbRespSearchResultContainer_itemSearch";
};
export type SbRespSearchResultContainer_itemSearch$data = SbRespSearchResultContainer_itemSearch;
export type SbRespSearchResultContainer_itemSearch$key = {
    readonly " $data"?: SbRespSearchResultContainer_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespSearchResultContainer_itemSearch">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "appliedFilters",
  "storageKey": null,
  "args": null,
  "concreteType": "SearchBrowseParsedParam",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "values",
      "storageKey": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParamValue",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "urlLabel",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "SbRespSearchResultContainer_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSearchQueryEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemSearchResult",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "item",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "SharedItemTile_item",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_itemSearch",
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedItemTrackingProvider_itemSearch",
      "args": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useSearchCorrections_itemSearch",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "searchCorrections",
          "storageKey": null,
          "args": null,
          "concreteType": "SearchCorrectionsType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "semanticSearchTerm",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "classificationLevel",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "classificationSearchTerm",
              "args": null,
              "storageKey": null
            }
          ]
        },
        (v0/*: any*/)
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedProductAdWrapper_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedItemTile_itemSearch",
      "args": null
    }
  ]
};
})();
(node as any).hash = '5ef92083abbc1798779a8ee72dbc3c2b';
export default node;
